import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
import ImportIcon from "components/import-export/import-icon"
import ExportIcon from "components/import-export/export-icon"
import Import from "components/import-export/import"
import ChartTable from "components/asset-management/chart/chart-table"
import { WithTip } from 'components/tooltip/with-tip'
// Data
import api_match from "data/interface/api"
import assetListService, { Asset } from "data/asset-list"
import chartService, { Chart } from "data/chart"
import userGroupService, { UserGroup } from "data/user-groups"
import importService from "data/import"
import { alphanum } from "components/table/lib/sort"
import { Errors } from "components/asset-management/errors"
import { ContextRow } from './chart-table'
import toggles from "feature-toggles"
//Styles
import { Chart_s } from "components/asset-management/chart/chart-styles"
import { AddIcon } from "images/icons/tools"
import validationService from 'data/validate'

const tableId = "chart-table"

const ChartComponent: FC<RouteComponentProps> = (props) => {
  const [data, setData] = useState<Chart[]>([])
  const [assetData, setAssetData] = useState<Asset[]>([])
  const [userGroups, setUserGroups] = useState<UserGroup[]>([])
  const [initSort, setInitSort] = useState<boolean>(false)
  const [showImport, toggleShowImport] = useState<boolean>(false)
  const [showSelected, setShowSelected] = useState<boolean>(false)
  const [selected, setSelected] = useState<ContextRow[]>([]);

  useEffect(() => {
    validationService.validate('chart')
  },[])

  useEffect(() => {
    importService.stream().subscribe(data => {
      toggleShowImport(data['showImport'])
    })

    toggleShowImport(false);

    const chartSubscription = chartService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          if (ok.value.length) setData(ok.value)
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const assetListSubscription = assetListService.stream().subscribe(data => {
      api_match(
        data,
        init  => setAssetData(init.value),
        ok    => {
          setAssetData(ok.value)
        },
        err   => {
          setAssetData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const userGroupSubscription = userGroupService.stream().subscribe(data => {
      let ug = data['groups'].map(group => { return group });
      setUserGroups(ug);
    })

    assetListService.fetchAssets()
    chartService.fetchCharts()
    userGroupService.fetchUserGroups()

    return function cleanup() {
      assetListSubscription.unsubscribe()
      chartSubscription.unsubscribe()
      userGroupSubscription.unsubscribe()
    }
  }, [])

  const Add = () => {
    return (
      <a onClick={() => chartService.create()}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  const [deleteFlag, setDeleteFlag] = useState(0)
  const Delete = () => {
    return (
      <WithTip position="bottom">
        <span>Delete Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput')  ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            setDeleteFlag(deleteFlag+1)
        }}>
          <span className="p-menuitem-icon pi pi-fw pi-trash"></span>
        </a>
      </WithTip>
    )
  }

  const [pasteFlag, setPasteFlag] = useState(0)
  const Paste = () => {
    return (
      <WithTip position="bottom">
        <span>Paste to Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput') ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            setPasteFlag(pasteFlag+1)
          }
        }>
          <span className="p-menuitem-icon pi pi-fw pi-clone"></span>
        </a>
      </WithTip>
    )
  }

  const ShowSelected = () => (
    <WithTip position="bottom">
      <span>Show {showSelected ? 'All' : 'Selected'} Rows</span>
      <a className={selected.length ? '' : 'disabled'}
        onClick={() => {
          if (!selected.length) return
          setShowSelected(!showSelected)
        }}>
        <span className={showSelected ? 'pi pi-eye-slash' : 'pi pi-eye'} style={{height: '18px', width: '18px'}}></span>
      </a>
    </WithTip>
  )

  useEffect(() => {
    setSelected(_.intersectionBy(data, selected, 'chartid'))
  }, [data])

  useEffect(() => {
    if (showSelected && _.isEmpty(selected)) setShowSelected(false)
  }, [selected])

  const _data = showSelected ? selected : data

  return (
    <Chart_s>
      <Toolbar>
        <Add />
        <Errors />
        {toggles.multiselect() && <>
          <Paste />
          <Delete />
          <ShowSelected />
        </>}
      </Toolbar>
      { showImport && <Import /> }
      { data && assetData && !showImport && <ChartTable tableId={tableId} data={_data} assets={assetData} userGroups={userGroups} selectedState={[selected, setSelected]} flags={{deleteFlag, pasteFlag}} /> }
    </Chart_s>
  )
}

export default ChartComponent
